"use client";

import { motion } from "framer-motion";
import React from "react";
import { featureSections } from "../data";

const TransformMeetingsSection = () => {
  return (
    <div className="w-full max-w-[80%] mx-auto flex flex-col lg:flex-row gap-8 mb-24">
      <motion.div 
        className="w-full lg:w-3/5"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.23 }}
      >
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
          Transform Meetings<br />
          into Actionable Outcomes
        </h2>
        <p className="text-[#38bdf8] text-xl mb-8 font-medium">
          Where Intelligence Meets Efficiency
        </p>

        <p className="text-slate-300 text-lg leading-relaxed">
          Tired of drowning in unproductive meetings? While tools like Otter.ai, Fathom, and Fireflies capture conversations, MeetMinutes AI goes further—turning discussions into decisions, notes into action, and meetings into momentum.
        </p>
      </motion.div>

      <div className="w-full lg:w-2/5 flex flex-col gap-4">
        {featureSections.map((feature, idx) => (
          <motion.div
            key={idx}
            className="relative"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.2, delay: idx * 0.03 }}
          >
            <div className="p-4 rounded-lg border border-slate-700/20 bg-slate-800/20 flex items-center">
              <div className="text-[#38bdf8] mr-4">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-white font-medium text-lg">{feature.title}</h3>
                <p className="text-slate-400 text-sm">{feature.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TransformMeetingsSection; 